'use strict';

require("core-js/modules/es.typed-array.set.js");

require("core-js/modules/es.typed-array.sort.js");

var implementation = require('./implementation');

module.exports = function getPolyfill() {
  return typeof Uint8Array === 'function' && Uint8Array.prototype.slice || implementation;
};